import { useUnit } from 'effector-react';
import { ManageMembersType, Permissions } from '@nx-frontend/shared/types';
import { $manageMembersType } from '../store';
import { PortalList } from './portal-list';
import { PortalNodeList } from './portal-node-list';

export function OrgAccessList({
  onUpdateMenuItemPermissions,
}: {
  onUpdateMenuItemPermissions?: (id: string, permissions: Permissions) => void;
}) {
  const [manageMembersType] = useUnit([$manageMembersType]);
  if (manageMembersType === ManageMembersType.PORTAL) {
    return <PortalList />;
  } else if (manageMembersType === ManageMembersType.PORTAL_NODE) {
    return <PortalNodeList onUpdateMenuItemPermissions={onUpdateMenuItemPermissions} />;
  } else {
    return <div>Unsupported type</div>;
  }
}

export default OrgAccessList;
